
class PricingTeaser {
  constructor(element, ...options) {
    this.defaults = {
      bookNowSelector: '.js-book-now',
      openOverlaySelector: '.js-open-content-overlay',
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    if (this.element.querySelector(this.options.bookNowSelector) !== null
    && this.element.querySelector(this.options.openOverlaySelector) !== null) {
      this.init();
    }
  }

  init() {
    this.bookNowElement = this.element.querySelector(this.options.bookNowSelector);
    this.openOverlayElement = this.element.querySelector(this.options.openOverlaySelector);
    this.select = document.querySelector(this.bookNowElement.dataset.target);

    this.bindEvents();
  }

  bookNow(e) {
    e.preventDefault();

    const selected = this.select.value;

    if (selected.includes('#content-overlay-event')) {
      this.openOverlayElement.dispatchEvent(new Event('click'));
    } else {
      const newTab = window.open();
      newTab.location.href = `https://meandcompany.myshopify.com/cart/${selected}:1?channel=buy_button`;
    }
  }

  bindEvents() {
    this.bookNowElement.addEventListener('click', this.bookNow.bind(this));
  }
}
